import { EMPLOYMENT_TYPES, TAX_CLASSIFICATIONS } from 'cpool-constants';
import { z } from 'zod';

import {
    BeschaeftigungAngestellter,
    BeschaeftigungArbeiter,
    BeschaeftigungArbeitsloser,
    BeschaeftigungAzubi,
    BeschaeftigungBeamter,
    BeschaeftigungFreiberufler,
    BeschaeftigungHausfrau,
    BeschaeftigungRentner,
    BeschaeftigungSelbststaendiger,
    BeschaeftigungStudent,
} from './Beschaeftigungsart';

const defaultBeschaeftigung = z.object({
    steuerklasse: z.nativeEnum(TAX_CLASSIFICATIONS).nullish().default(null),
});
export const Beschaeftigung = z
    .discriminatedUnion('beschaeftigungsart', [
        z
            .object({
                beschaeftigungsart: z.null(),
            })
            .merge(defaultBeschaeftigung),
        z
            .object({
                angestellter: BeschaeftigungAngestellter.optional(),
                beschaeftigungsart: z.literal(EMPLOYMENT_TYPES.ANGESTELLTER),
            })
            .merge(defaultBeschaeftigung),
        z
            .object({
                arbeiter: BeschaeftigungArbeiter.optional(),
                beschaeftigungsart: z.literal(EMPLOYMENT_TYPES.ARBEITER),
            })
            .merge(defaultBeschaeftigung),
        z
            .object({
                arbeitsloser: BeschaeftigungArbeitsloser.optional(),
                beschaeftigungsart: z.literal(EMPLOYMENT_TYPES.ARBEITSLOSER),
            })
            .merge(defaultBeschaeftigung),
        z
            .object({
                beamter: BeschaeftigungBeamter.optional(),
                beschaeftigungsart: z.literal(EMPLOYMENT_TYPES.BEAMTER),
            })
            .merge(defaultBeschaeftigung),
        z
            .object({
                beschaeftigungsart: z.literal(EMPLOYMENT_TYPES.FREIBERUFLER),
                freiberufler: BeschaeftigungFreiberufler.optional(),
            })
            .merge(defaultBeschaeftigung),
        z
            .object({
                beschaeftigungsart: z.literal(EMPLOYMENT_TYPES.HAUSFRAU),
                hausfrau: BeschaeftigungHausfrau.optional(),
            })
            .merge(defaultBeschaeftigung),
        z
            .object({
                beschaeftigungsart: z.literal(EMPLOYMENT_TYPES.RENTNER),
                rentner: BeschaeftigungRentner.optional(),
            })
            .merge(defaultBeschaeftigung),
        z
            .object({
                beschaeftigungsart: z.literal(EMPLOYMENT_TYPES.SELBSTSTAENDIGER),
                selbststaendiger: BeschaeftigungSelbststaendiger.optional(),
            })
            .merge(defaultBeschaeftigung),
        z
            .object({
                azubi: BeschaeftigungAzubi.optional(),
                beschaeftigungsart: z.literal(EMPLOYMENT_TYPES.AZUBI),
            })
            .merge(defaultBeschaeftigung),
        z
            .object({
                beschaeftigungsart: z.literal(EMPLOYMENT_TYPES.STUDENT),
                student: BeschaeftigungStudent.optional(),
            })
            .merge(defaultBeschaeftigung),
    ])
    .nullable()
    .optional()
    .default(null);

export type Schema_Beschaeftigung = z.infer<typeof Beschaeftigung>;
